@if (update.prompt() === 'bar') {
  <div
    role="status"
    aria-live="polite"
    data-testid="update-bar"
    class="fixed left-0 top-0 z-[1100] flex h-[32px] w-full items-center justify-center gap-3 px-10 text-sm text-white"
    [class.bg-primary]="!update.mustReload()"
    [class.bg-red]="update.mustReload()">
    @if (update.mustReload()) {
      <span>Dormotech needs to reload to keep working. Save your work, then click Reload.</span>
    } @else {
      <!-- Any page load applies it, so closing the bar only lasts until the next visit. -->
      <span>A new version of Dormotech is ready. It will be applied the next time you open Dormotech.</span>
    }
    <!-- White on the bar, label in the bar's colour, short enough to fit it. -->
    <button
      mat-flat-button
      type="button"
      style="--mdc-filled-button-container-color: #fff; --mdc-filled-button-container-height: 26px"
      [style.--mdc-filled-button-label-text-color]="update.mustReload() ? barColors.reload : barColors.update"
      (click)="update.updateNow()">
      {{ update.mustReload() ? 'Reload' : 'Update now' }}
    </button>
    <!-- A broken version has to be reloaded, so only the update can wait. -->
    @if (!update.mustReload()) {
      <button
        mat-icon-button
        type="button"
        aria-label="Close"
        data-testid="update-bar-close"
        class="absolute right-3"
        (click)="update.later()">
        <mat-icon class="text-white">close</mat-icon>
      </button>
    }
  </div>
}

@if (update.prompt() === 'updated') {
  <div
    role="status"
    aria-live="polite"
    data-testid="updated-bar"
    class="fixed left-0 top-0 z-[1100] flex h-[32px] w-full items-center justify-center gap-1 bg-primary px-10 text-sm text-white">
    <span>Dormotech was updated to the latest version.</span>
    @if (releaseNotesUrl) {
      <a
        class="font-medium text-white underline"
        target="_blank"
        rel="noopener"
        [href]="releaseNotesUrl">
        See what's new
      </a>
    }
    <button
      mat-icon-button
      type="button"
      aria-label="Close"
      data-testid="updated-bar-close"
      class="absolute right-3"
      (click)="update.closeUpdatedNotice()">
      <mat-icon class="text-white">close</mat-icon>
    </button>
  </div>
}
